import { render, staticRenderFns } from "./user-courses.vue?vue&type=template&id=97edd80a&"
import script from "./user-courses.vue?vue&type=script&lang=js&"
export * from "./user-courses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports